import { modelTypes } from 'constants'

export default function getInitialState() {
    const initialState = {
        ...window.INITIAL_STATE,
    }; 

    const categoryPage = window[modelTypes.categoryCurrentPage] || null
    const searchPage = window[modelTypes.searchPage] || null
    const comparePage = window[modelTypes.productsToCompare] || null
    const routes = window.__ROUTES || {}; 

    if (categoryPage) {
        initialState.currentPage = { ...initialState.currentPage, ...categoryPage }
    }

    if (searchPage) {
        initialState.currentPage = { ...initialState.currentPage, ...searchPage }
    }

    if (comparePage) {
        initialState.compareProducts = { ...initialState.compareProducts, ...comparePage }
    }

    if (routes) {
        initialState.routes = { ...initialState.routes, ...routes } 
    }

    return initialState
}
